export interface NarrativeFlowOpenTarget {
  sessionId: string;
  conversationId?: string | null;
  source?: string | null;
}

const PENDING_KEY = "fintheon:pending-narrativeflow-open:v1";

export function parseNarrativeFlowOpenUrl(
  rawUrl: string,
): NarrativeFlowOpenTarget | null {
  try {
    const url = new URL(rawUrl);
    if (url.protocol.toLowerCase() !== "fintheon:") return null;
    const host = url.hostname.toLowerCase();
    const path = url.pathname.replace(/^\/+/, "").toLowerCase();
    if (host !== "narrativeflow" && path !== "narrativeflow") return null;
    const sessionId = url.searchParams.get("sessionId")?.trim();
    if (!sessionId) return null;
    return {
      sessionId,
      conversationId: url.searchParams.get("conversationId")?.trim() || null,
      source: url.searchParams.get("source")?.trim() || null,
    };
  } catch {
    return null;
  }
}

export function storePendingNarrativeFlowOpen(
  target: NarrativeFlowOpenTarget,
): void {
  try {
    localStorage.setItem(PENDING_KEY, JSON.stringify(target));
    localStorage.setItem("fintheon:pending-consilium-surface", "narrativeflow");
  } catch {
    /* ignore */
  }
}

export function consumePendingNarrativeFlowOpen(): NarrativeFlowOpenTarget | null {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    localStorage.removeItem(PENDING_KEY);
    const parsed = JSON.parse(raw);
    if (!isRecord(parsed) || typeof parsed.sessionId !== "string") return null;
    return {
      sessionId: parsed.sessionId,
      conversationId:
        typeof parsed.conversationId === "string"
          ? parsed.conversationId
          : null,
      source: typeof parsed.source === "string" ? parsed.source : null,
    };
  } catch {
    return null;
  }
}

export function dispatchNarrativeFlowOpen(
  target: NarrativeFlowOpenTarget,
): void {
  window.dispatchEvent(
    new CustomEvent<NarrativeFlowOpenTarget>(
      "fintheon:narrativeflow-open-session",
      { detail: target },
    ),
  );
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return Boolean(value && typeof value === "object" && !Array.isArray(value));
}
